import { render, staticRenderFns } from "./sessionDetail.vue?vue&type=template&id=6b8539f4&scoped=true&lang=pug&"
import script from "./sessionDetail.vue?vue&type=script&lang=js&"
export * from "./sessionDetail.vue?vue&type=script&lang=js&"
import style0 from "./sessionDetail.vue?vue&type=style&index=0&id=6b8539f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8539f4",
  null
  
)

export default component.exports